import styled from 'styled-components';
import { spacing, colors, borderRadius, Caption, Overline } from 'ui/theme';
import { pxToRem } from 'utils/convert';

export const UnscoredUnsubsubcribeMetricsCard = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${spacing.half};
  padding: ${spacing.plusHalf};
  background-color: ${colors.backgroundSecondary};
  border-radius: ${borderRadius.lg};
  height: 100%;
  width: ${pxToRem(560)};
`;

export const UnsubscribeTopContainer = styled.div`
  display: flex;
  justify-content: space-between;
`;

export const UnsubscribeTitle = styled(Overline)`
  color: ${colors.textSecondary};
  margin-bottom: ${spacing.plusHalf};
`;

export const UnscoredUnsubsubcribeMetricsContainer = styled.div`
  display: grid;
  grid-template-rows: 1fr;
  grid-template-columns: 1fr 1fr;
  gap: ${spacing.half};
`;

export const LeftMessagingContainerFlex = styled.div`
  display: flex;
  align-items: center;
  gap: ${spacing.half};
`;
export const MainMessagingInfoFlex = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${spacing.quarter};
`;

export const RightMessagingContainerFlex = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: ${spacing.quarter};
`;

export const SecondaryCaption = styled(Caption)`
  color: ${colors.textSecondary};
`;

export const SpacingOffsetIndex = styled(SecondaryCaption)`
  margin-right: ${spacing.half};
`;
export const SpacingOffsetCount = styled(SecondaryCaption)`
  margin-left: ${spacing.plusQuarter};
`;
